module.exports = __webpack_public_path__ + "fonts/sk_icons.3e9c7fc.ttf";